// eslint-disable-next-line import/prefer-default-export
export const API_END_POINT = 'https://flexlayerdev.flextg.com/api/v1/deal-packet';
export const GOOGLE_GEO_CODE_KEY='AIzaSyAJJkMB-gw2AX3911C0kyPqW4V0pW5ZYAo';
